import '../../styles/triple-oaks.css';
import town_sketch from "url:../../assets/town-sketch.png";
import newspaper from "url:../../assets/trok/trok-news.png";
import { Blips } from '../../components/Blips';
import { TROK0 } from './TROK0';;
import { useContext } from 'react';
import TripleOaksProvider, { TripleOaksContext } from './TripleOaksProvider';
import { SiteUpdates } from '../../components/SiteUpdate';
import { Smashable } from '../../components/cursor/Smashable';

export function TROKH() {
    const trokContext = useContext<TripleOaksContext>(TripleOaksProvider.context);

    return <div className='trok-main-width v-box gap-32'>
        <div className='trok-main'>
            <h2 className='trok-text'>Welcome to Triple Oaks!</h2>
            <Smashable>
                <p className='trok-text text-white'>Triple Oaks is a lively town nestled in the Heartland. <i>F</i>ounded in 1828, Triple Oaks has a long, storied history of proud American fortitude and <i>i</i>nnovation.</p>
            </Smashable>
            <Smashable>
                <p className='trok-text text-white'>Triple Oaks has multiple claims to fame! A beacon of agriculture, we grow many essential crops like cor<i>n</i> and soybeans. We have also become popular with cryptozoologists camping out for a glimpse at local legen<i>d</i>s like Mothfoot.</p>
            </Smashable>
            <Smashable>
                <p className='trok-text text-white'>Our town is most well-known for the Flushmore Toilet Factory. In 1993, Flushmore Enterprises revealed <i>M</i>ount Flushmore to commemorate their history in our town. Through feast and famine, Flushmore <i>E</i>nterprises has supported this town and its 2400 residents, so if you’re traveling along I-70, make sure to stop by and snap a pic of our town’s great landmark!</p>
            </Smashable>
            
            <span className='trok-sp'>This message is sponsored by Flushmore Enterprises.</span>
            <Blips onSuccess={() => {
                trokContext.setLair(true);
            }} />
            <br/>
            <Smashable>
                <h3 className='trok-text'>Want To Visit?</h3>
            </Smashable>
            <Smashable>
                <img width="100%" src={town_sketch} className='trok-box'/>
            </Smashable>
            <p>Check out <a href="/tripleoaks/construction">[What to Do]</a> for ways to immerse yourself in the local culture.</p>
            {/* <div id='trokslot' style={{width: 140, height: 170}}>
                <Draggable 
                    id={"trokslotty"} 
                    sourceId='trokslot' 
                    stickToSource={true}
                    targetId='lefttree'
                    x={0} y={0} w={140} h={170} 
                    content={<img id={"trokslotty"} src={spooky_tree} style={{width: 140, height: 170}} 
                />} />
            </div> */}
            <br/>
            <div className='trok-news-box'>
                <Smashable>
                    <img src={newspaper} className='trok-news-icon' />
                </Smashable>
                <div className='trok-news-box-a'>
                    <div className='trok-leaf-divider' />
                    <span className='trok-news-header'>TRIPLE OAKS IN THE NEWS</span>
                    <div className='trok-leaf-divider' />
                </div>
            </div>
        </div>

        <SiteUpdates
            headerContents={
                <h2>Site Updates</h2>
            }
            updates={[
                {
                    headerContents: <h3>2-5-2001</h3>,
                    bodyContents: <p>Going dark on this site. They brought in an outside contractor to build the new site, so this one will be depreciated. Thanks for all the fish!  If you know where to find me, find me there.</p>
                },
                {
                    headerContents: <h3>1-8-2000</h3>,
                    bodyContents: <p>Town received a grant for modernization! I’m told this means we can build a brand new, beautiful site. Many pages going under construction to test new styling. Do not be alarmed! </p>
                },
                {
                    headerContents: <h3>1-1-2000</h3>,
                    bodyContents: <p>Can anyone hear me in the new millennium? Did we survive? If we can do that together, we can do anything. Invented hoverboards and that robot dog from the Jetsons. Website didn’t crash. HAPPY NEW YEAR!</p>
                },
                {
                    headerContents: <h3>12-31-1999</h3>,
                    bodyContents: <p>See you in the future.... I hope!</p>
                },
                {
                    headerContents: <h3>8-27-1999</h3>,
                    bodyContents: <p>Added a daily quotes section. Send me your favorites, and you might see them on the town website! </p>
                },
                {
                    headerContents: <h3>6-17-1999</h3>,
                    bodyContents: <p>Added visitor counter to the site. We may be a small town, but we’re the life of the party once you get to know us.</p>
                },
                {
                    headerContents: <h3>3-3-1999</h3>,
                    bodyContents: <p>improved performance, fixed typo on community calendar</p>
                },
                {
                    headerContents: <h3>7-19-1998</h3>,
                    bodyContents: <p>Changed home page display, width of boxes expanded</p>
                },
                {
                    headerContents: <h3>5-16-1998</h3>,
                    bodyContents: <p>updated tourism mentions to be compliant -k</p>
                },
                {
                    headerContents: <h3>2-25-1998</h3>,
                    bodyContents: <p>Updated What To Do and Home for notable tourism spots and highlights.</p>
                },
                {
                    headerContents: <h3>10-31-1997</h3>,
                    bodyContents: <p>Ate too much candy… but just one more byte ROFL. Happy Halloween!</p>
                },
                {
                    headerContents: <h3>10-23-1997</h3>,
                    bodyContents: <p>Trick or Treating schedule uploaded. Added Halloween icons for atmosphere. Be safe, and don’t forget to check your candy! Trick or Treat for Unicef boxes available at library.</p>
                },
                {
                    headerContents: <h3>8-26-1997</h3>,
                    bodyContents: <p>New author appears! Hello! I will be taking the seat of Webmaster from this point on. Thanks for keeping my cyber seat warm, Kevin. I’m just a hobbyist helping out my friends who work for the town, so everyone be nice! X3</p>
                },
                {
                    headerContents: <h3>8-23-1997</h3>,
                    bodyContents: <p>roger. test a success. don’t yell lol -k</p>
                },
                {
                    headerContents: <h3>8-22-1997</h3>,
                    bodyContents: <p>TEST TEST TEST TEST!!! CAN YOU HEAR ME NOW??</p>
                },
                {
                    headerContents: <h3>8-21-1997</h3>,
                    bodyContents: <p>site performance issues resolved. help brought on to maintain site. last update was a test -k</p>
                },
                {
                    headerContents: <h3>8-20-1997</h3>,
                    bodyContents: <p>Can you hear me?</p>
                },
                {
                    headerContents: <h3>5-14-1997</h3>,
                    bodyContents: <p>typos fixed, broken links updated -k</p>
                },
                {
                    headerContents: <h3>3-5-1997</h3>,
                    bodyContents: <p>town logo updated -k</p>
                },
                {
                    headerContents: <h3>1-10-1997</h3>,
                    bodyContents: <p>site launched</p>
                }
            ]}
        />
    </div>
}